import { Container, MainContent, Separator } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Route, Routes } from 'react-router';

import AppModalProvider from './components/invoice/AppModalProvider';
import WarningNotice from './components/invoice/notices/WarningNotice';
import { StaticRoutes } from './Routes';
import { IRouteStore } from './stores/RouteStore';

interface MainContentContainerState {
  hasError: boolean;
}

interface MainContentContainerProps {
  routeStore?: IRouteStore;
}

@inject('routeStore')
@observer
export default class MainContentContainer extends React.Component<MainContentContainerProps, MainContentContainerState> {
  constructor(props: unknown) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ hasError: true });
    console.error(error, errorInfo);
  }

  public render(): JSX.Element {
    if (this.state.hasError) {
      return (
        <MainContent>
          <Container>
            <Separator spacing="medium" color="invisible" />
            <WarningNotice translationKey="shared.errors.technical" />
          </Container>
        </MainContent>
      );
    }

    return (
      <MainContent>
        <Routes location={this.props.routeStore.location}>
          {StaticRoutes.map((routeProps, index) => (
            <Route key={`route-${index}`} {...routeProps} />
          ))}
        </Routes>
        <AppModalProvider />
      </MainContent>
    );
  }
}
